var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('HeaderPurchase',{attrs:{"header":"เพิ่มข้อมูลซัพพลายเออร์","img_header":_vm.header_image,"link_back":"supplier"}}),_c('SupplierFrom')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }